var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDzen = function SvgDzen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.443 5.009a11.204 11.204 0 0 0-.671-.007c-.06 4.487-.374 7.016-2.064 8.706-1.69 1.69-4.22 2.005-8.706 2.064a11.191 11.191 0 0 0 .007.671c4.482.059 7.01.374 8.699 2.064 1.663 1.663 1.995 4.138 2.06 8.49a11.145 11.145 0 0 0 .678-.006c.066-4.349.398-6.822 2.06-8.484 1.663-1.663 4.136-1.995 8.485-2.06a11.203 11.203 0 0 0 .007-.678c-4.353-.066-6.828-.398-8.491-2.061-1.69-1.69-2.005-4.217-2.064-8.7Z",
    fill: "#151515"
  })));
};
export default SvgDzen;